import { Badge, RemoveButton } from "~/components/reusable/Badge"
import { cn } from "~/utils/helpers"

export type Tag = { id: number; name: string }

type TagBadgeWithRemoveProps = {
  tag: Tag
  isActive?: boolean
  canEdit?: boolean
  onFilterClick: (tag: Tag) => void
  onRemove: (tag: Tag) => void
  className?: string
  tooltipTitle?: string
}

export function TagBadgeWithRemove({
  tag,
  isActive = false,
  canEdit = false,
  onFilterClick,
  onRemove,
  className,
  tooltipTitle,
}: TagBadgeWithRemoveProps) {
  return (
    <Badge
      variant="tag"
      isActive={isActive}
      className={cn("max-h-[22px] cursor-pointer relative", className)}
      onClick={() => onFilterClick(tag)}
    >
      <span className="max-w-28 truncate leading-normal">{tag.name}</span>
      {canEdit && (
        <RemoveButton
          selected={isActive}
          onRemove={() => onRemove(tag)}
          tooltipTitle={tooltipTitle}
        />
      )}
    </Badge>
  )
}
